import { useEffect, useState } from "react";
import tw from "twin.macro";
// import SliderImage from "react-zoom-slider";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  currentDateToUtcDate,
  filterFormatFromDate,
  filterFormatToDate,
  getCurrentTimeConfig,
  INITIAL_SELECT_VALUE,
  YEAR_WISE_FORMAT,
} from "utility/Constant";
import {
  getBranchId,
  getCustomerId,
} from "../utility/HeaderConfig.js";
import {
  createCustomerWish,
  deleteCustomerWish,
} from "api/Like&WishCountApi";
import "react-loading-skeleton/dist/skeleton.css";
import toast, { Toaster } from "react-hot-toast";
// import Pincode from "components/Pincode";
// import ReactImageMagnify from 'react-image-magnify';
import moment from "moment";
import {getPayULinkData } from "api/AppConfigApi";
import tryit from "../../src/images/Thanshiq/try-it-on-camera-icon.svg"
import ad from "../../src/images/Thanshiq/Dazzling_Grace_Drop_Earrings/Ad.png"
import { Accordion } from "react-bootstrap";
import ZoomableImage from "./ZoomableImage";
// import { createEnquiry, EmplyeeId, EnquierySource, EnquieryStatus, EnquieryTypeId, Language } from "api/BookAnAppointmentApi";
import { PurityApi } from "api/PurityApi";
import { createProductOrder, getAllFinancialYear, getAllPaymentMode } from "api/CheckOutApi";
import {  getAllSection, getAllTax } from "api/VelProductApi";
import { getOrderStatusId } from "utility/UtilFunction";
// import AffordabilityWidget from "./AffordabilityWidget";
import { getAllProductSubCate } from "api/ProductSubCateApi";
import { useCartContext } from "context/UseCartContext";
//eslint-disable-next-line
import { authorization, getAuthHeader } from "utility/PayuHeaderConfig.js";

const StyledDiv = tw.div`font-display overflow-hidden md:overflow-visible `;



export default ({ configImages }) => {
  const [totalAmount,setTotalAmount] = useState(0)
  const [openCustomizationKey, setOpenCustomizationKey] = useState("metal");
  // const [scheduleDate] = useState(
  //     moment().add(1, "hours").format("YYYY-MM-DDTHH:mm")
  //   );
  // const [EnquieryStatusId, setEnquieryStatusId] = useState("");
  // const [EnquieryTypeid, setEnquieryTypeid] = useState("");
  // const [currentlang, setCurrentlang] = useState([]);
  // const [EmployeeId, setEmployeeId] = useState("");
  // const [EnquieryId, setEnquieryId] = useState("");
  const [selectedGrams, setSelectedGrams] = useState("");
  const [selectedMetal, setSelectedMetal] = useState("Gold");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [Img] = useState([]);
  const [currentImg, setCurrentImg] = useState([]);
  const [wishState, setWishState] = useState({});
  const [categoryItem, setCategoryItem] = useState({});
  const [productInfo,setProductInfo] = useState('');
  const [taxData,setTaxData] = useState('');
  const [makingChargeInfo,setMakingChargeInfo] = useState('');
  const [wastageInfo,setWastageInfo] = useState('');
  const [goldRate,setGoldRate] = useState(0);
  const [silverRate,setSilverRate] = useState(0);
  const [financialyear,setFinancialYear] = useState('');
  const [goldType,setGoldType] = useState('');
  const [silverType,setSilverType] = useState('')
  const [selectedTax,setSelectedTax] = useState(INITIAL_SELECT_VALUE);
  const [selectedPayment,setSelectedPayment] = useState(INITIAL_SELECT_VALUE)
  const [goldPurityId,setGoldPurityId] = useState('')
  const [silverPurityId,setSilverPurityId] = useState('')
  const [selectedFloor,setSelectedFloor] = useState(INITIAL_SELECT_VALUE)
  const [selectedSelection,setSelectedSection] = useState(INITIAL_SELECT_VALUE)
  const [orderStatus,setOrderStatus] = useState(INITIAL_SELECT_VALUE)
  const [productCategory,setProductCategory] = useState(INITIAL_SELECT_VALUE)
  const [prodSubCategory,setProdSubCategory] = useState(INITIAL_SELECT_VALUE)
  // const [opengateWay, setOpengateWay] = useState(false);
  const [selectedTab, setSelectedTab] = useState("customization");
  const [categoryInfo,setCategoryInfo] = useState('');
  const [descriptionInfo,setDescriptionInfo] = useState('')
  const [colorCode,setColorCode] = useState('')
  // const [transData,setTransData] = useState('');


  const isMetalSelected = !!selectedMetal;
  const isMandatory = (selectedMetal === '' || selectedCategory === '' || selectedSize === '' || selectedGrams === '')
  const location = useLocation();
  const navigate = useNavigate();

  const { dispatch } = useCartContext();

  const handleButtonClick = () => {
    navigate('/NewArrivals');
  };


  useEffect(() => {
     Promise.all([
      getVelProductInfo(),
      getProductRate(),
      getFinacialYearData(),
      getPaymentData(),
      getProductOrderStatus(),
      // EnquierySourceId(),
      getTaxData(),
      // EnquierySourceStatus(),
      // EnquieryEmployeeId(),
      // EnquieryType(),
      // Selectlanguage(),
    ])
    return () => { };
    //eslint-disable-next-line
  }, []);


  const getVelProductInfo = () => {
    const params = new URLSearchParams(window.location.search);
    const dataParam = params.get("data");
    let categoryDetails = dataParam ? JSON.parse(decodeURIComponent(dataParam)) : null
    console.log("categoryItem",categoryDetails);
    if (location?.state?.categoryItem) {
        setCategoryInfo(
          location?.state?.language?.label === 'English' ? 
          location?.state?.categoryItem?.categoryName : location?.state?.categoryItem?.categoryNameTa
        )
        setDescriptionInfo(
           location?.state?.language?.label === 'English' ? 
          location?.state?.categoryItem?.description :location?.state?.categoryItem?.descriptionTa
        )
        setProductInfo(
          location?.state?.language?.label === 'English' ? 
          location?.state?.categoryItem?.productName : location?.state?.categoryItem?.productNameTa
        )
        setCurrentImg(location?.state?.categoryItem?.Url)
        setColorCode(location?.state?.categoryItem?.colorCode)
        // setSelectedMetal(location?.state?.categoryItem?.material)
    } else if (categoryDetails !== null) {
      setCategoryInfo(
        categoryDetails?.language.label === 'English' ? 
        categoryDetails?.categoryItem.categoryName :
        categoryDetails?.categoryItem.categoryNameTa
      )
      setDescriptionInfo(
         categoryDetails?.language.label === 'English' ? 
        categoryDetails?.categoryItem.description :categoryDetails?.categoryItem.descriptionTa
      )
      setProductInfo(
          categoryDetails?.language.label === 'English' ? 
          categoryDetails?.categoryItem?.productName : categoryDetails?.categoryItem?.productNameTa
        )
        setCurrentImg(categoryDetails?.categoryItem?.Url)
        setColorCode(categoryDetails?.categoryItem?.colorCode)
    }
  }

  const handleWhatsAppClick = () => {
    const phoneNumber = '919283916916';
    const message = `Hi, I'm interested in: ${productInfo}\nMetal: ${selectedMetal?.label || 'Not selected'}\nCategory: ${selectedCategory || 'Not selected'}\nGrams: ${selectedGrams || 'Not selected'}\nPlease help me with further discussions.`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
};


  useEffect(() => {
  if (selectedMetal === "Gold") {
    const data = getGoldProductCustomizationData();
    setCategoryItem(data);
    getSectionDetails();
    getCategoryDetails();
  } else if (selectedMetal === "Silver") {
    const silverInfo = getSilverProductCustomizationData();
    setCategoryItem(silverInfo)
    getSectionDetails();
    getCategoryDetails();
  }
  //eslint-disable-next-line
}, [selectedMetal]);

const getProductOrderStatus = async() => {
  let OrderDetails = ''
  const responseData = await getOrderStatusId()
  responseData.response.forEach(item => {
    if (item.orderStatusName.toLowerCase() === 'confirmed') {
      OrderDetails = item
    }
  })
  setOrderStatus(OrderDetails)
}

const getCategoryDetails = () => {
  let filterData = {}
  if (selectedMetal === 'Gold') {
    filterData = {
      subCategoryName:'108 GOLD MAHA VEL'
    }
  } else if (selectedMetal === 'Silver') {
    filterData = {
      subCategoryName:'108 SILVER MAHA VEL'
    }
  }
  const responseData = getAllProductSubCate(filterData)
  const categoryList = []
  const subCategoryList = []
  responseData.then(
    data => {
      data.response.forEach(item => {
        categoryList.push({
          value:item.metaProdCateId,
          label:item.metaProdCateName
        })
        subCategoryList.push({
          value:item.id,
          label:item.subCategoryName
        })
      })
      console.log('dsds',data.response);
      setProductCategory(categoryList)
      setProdSubCategory(subCategoryList)
    }
  )
}

const getFinacialYearData = () => {
  const filterData = {
    isDefault: 1
  };
  const responseData = getAllFinancialYear(filterData);
  responseData.then(
    data => {
      setFinancialYear(data[0]?.id)
    }
  )
}

const getTaxData = () => {
  const filterData = {
    branch:getBranchId(),
    active:1,
    module: 'Sale'
  }
  const respData = getAllTax(filterData)
  const taxList = [];
  respData.then (
    data => {
      data.response.forEach(item => {
        if (item.chargeName === 'CGST') {
          const taxValue = `${item.chargeName}-${item.chargeValue}`;
          taxList.push({
            value:item.id,
            label:taxValue,
            name: item.chargeName,
					  percent: item.chargeValue
          })
        }
      })
      setSelectedTax(taxList)
    }
  )
}

const getPaymentData = () => {
  const responseData = getAllPaymentMode();
  responseData.then(
    data => {
      const paymentModeList = []
      data.response.forEach(item => {
        if (item.name === "G-PAY") {
          paymentModeList.push({
            value:item.id,
            label:item.name
          })
        }
      })
      setSelectedPayment(paymentModeList)
    }
  )
}

 const getProductRate = async () => {
    let fromDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    let toDate = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    let silverRate = '';
    let goldRate = '';
    let goldPurityData = '';
    let silverPurityData = '';
    let goldProductTypeInfo = ''
    let silverProductTypeInfo = ''
    const filterData = {
      branch: getBranchId(),
      createdAtFrom: filterFormatFromDate(fromDate),
      createdAtTo: filterFormatToDate(toDate),
    };
    const todayMetalRate = await PurityApi(filterData);
    todayMetalRate.response.forEach(item => {
      if (item.metaProdTypeName === 'Gold' && item.purity === '22K - 91.6%') {
        goldRate = Math.trunc(item.onlineRate)
        goldProductTypeInfo = item.metaProdTypeId
        goldPurityData = item.purityId
      }
      if (item.metaProdTypeName === "Silver" && item.purity === '90%') {
        silverRate = Math.trunc(item.onlineRate)
        silverProductTypeInfo = item.metaProdTypeId
        silverPurityData = item.purityId
      }
    })
    setGoldPurityId(goldPurityData)
    setSilverPurityId(silverPurityData)
    setGoldRate(goldRate)
    setGoldType(goldProductTypeInfo)
    setSilverType(silverProductTypeInfo)
    setSilverRate(silverRate)
    
  };


  const getSectionDetails = () => {
    let filterData = ''
    if (selectedMetal === 'Gold') {
      filterData = {sectionName : '108 GOLD MAHAVEL'}
    } else if (selectedMetal === 'Silver') {
      filterData = {sectionName : '108 SILVER MAHAVEL'}
    }
    const responseData = getAllSection(filterData);
    const sectionList = []
    const floorList = []
    responseData.then (
      data => {
        data.response.forEach(item => {
          sectionList.push({
            value:item.id,
            label:item.sectionName
          })
          floorList.push({
            value:item.floorId,
            label:item.floorNumber
          })

        })
        setSelectedSection(sectionList)
        setSelectedFloor(floorList)
      }
    )

  }

  const getPriceData = (grams) => {
    let productRate = 0
    let taxInfo = 0
    let finalTotal = 0
    const gramsInfo = grams;
    if (selectedMetal === 'Gold') {
      productRate = goldRate
      const wastageCost = 18.2 / 100
      const makingCharge = selectedCategory === 'GETTI PIPE ROUND GENTS KADA' ? 550 : 750
     const  productRateCalc = Math.round(gramsInfo * productRate);
      const wastageAmtCalc = gramsInfo * wastageCost
      const makingChargeCalc = makingCharge * gramsInfo
      const wastageProductCalc = wastageAmtCalc *  productRate
      setWastageInfo(wastageProductCalc)
      setMakingChargeInfo(makingChargeCalc)
      taxInfo = (productRateCalc + wastageProductCalc + makingChargeCalc) * 3/100
      finalTotal = (productRateCalc + wastageProductCalc + makingChargeCalc) + taxInfo
    } else if (selectedMetal === 'Silver') {
      productRate = silverRate
      const silverRateCalc = Math.round(gramsInfo * productRate);
      const wastageInfo = 150/100
      const wastageGramInfo = gramsInfo * wastageInfo
      const silverWastage = wastageGramInfo * productRate
      taxInfo = (silverRateCalc + silverWastage) * 3/100
      finalTotal =(silverRateCalc + silverWastage) + taxInfo
    }
    setTaxData(taxInfo)
    setTotalAmount(Math.round(finalTotal))
    

  }

   const buynow = () => {
    if (selectedGrams === '' || selectedMetal === '' || selectedCategory === '' || selectedSize === '') {
      toast.error('To continue with your booking, please complete the required fields.')
      return;
    } else {
      if (getCustomerId()) {
        // createCustomerEnquiry()
        addProductOrderDetails()
        // navigate("/CheckoutPage", { state: { Details, prdctId: Details.id , isBuyNow: 'buyNow' } });
      } else {
        dispatch({ type: "MODAL", payload: "login" });
      }
    }
  }

  const wishCountFunc = (product) => {
    if (getCustomerId() && getCustomerId() !== "onlinepayment") {
      const productId = product.productId ? product.productId : product.id;
      setWishState((prevState) => ({
        ...prevState,
        [productId]: !prevState[productId],
      }));

      if (wishState[productId]) {
        const deletWish = `customerId=${getCustomerId()}&productId=${productId}`;
        deleteCustomerWish(deletWish);
      } else {
        const createWish = `customerId=${getCustomerId()}&productId=${productId}&remark=liked`;
        createCustomerWish(createWish);
      }
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  // const EnquierySourceId = () => {
  //   EnquierySource().then((data) => {
  //     if (data.response.length > 0 && data) {
  //       let enquiryName = data.response;
  //       // filter(
  //       //   (item) => item.name && item.name.toLowerCase() === "web"
  //       // );
  //       let selectedEnquirySource = enquiryName.filter(item => item.name === 'ECOMM_WEB' || 'YOUTUBE')
  //         // enquiryName.length > 0 ? enquiryName[9].id : "";
  //       setEnquieryId(selectedEnquirySource);
  //     }
  //   });
  // };

  // const EnquierySourceStatus = () => {
  //     EnquieryStatus().then((data) => {
  //       if (data.response.length > 0 && data) {
  //         let enquiryId = data.response.filter(
  //           (item) => item.name && item.name.toLowerCase() === "hot"
  //         );
  //         let selectedEnquiryId = enquiryId.length > 0 ? enquiryId[0].id : "";
  //         setEnquieryStatusId(selectedEnquiryId);
  //       }
  //     });
  //   };

  //   const EnquieryEmployeeId = () => {
  //   const employee = {
  //     name: "ONLINEPAYMENT",
  //   };
  //   EmplyeeId(JSON.stringify(employee)).then((data) => {
  //     if (data.response.length > 0 && data) {
  //       let enquiryName = data.response;
  //       let selectedEnquirySource =
  //         enquiryName.length > 0 ? enquiryName[0].id : "";
  //       setEmployeeId(selectedEnquirySource);
  //     }
  //   });
  // };

  //  const EnquieryType = () => {
  //     EnquieryTypeId().then((data) => {
  //       if (data.response.length > 0 && data) {
  //         let enquiryTypeId = data.response.filter(
  //           (item) => item.name && item.name.toLowerCase() === "sales"
  //         );
  //         let selectedEnquiryTypeId =
  //           enquiryTypeId.length > 0 ? enquiryTypeId[0].id : "";
  //         setEnquieryTypeid(selectedEnquiryTypeId);
  //       }
  //     });
  //   };

    // const Selectlanguage = async() => {
    //     let languageList = [];
    //     const languageResData = await Language();
    //     if(languageResData.response && languageResData.response.length > 0){
    //       languageResData.response.forEach((item) => {
    //         const data = {
    //           value: item.id,
    //           title: item.languageName,
    //           selected: false,
    //         };
    //         languageList.push(data);
    //       });
    //     };
    //     let defValue = languageList.filter(language => language.title.toLowerCase() === "tamil");
    //     setCurrentlang(defValue);
    //   };

  const getGoldProductCustomizationData = () => {
    const customizationData = [
  {
    "name": "916 HOLLOW RING ",
    "gender":["UNISEX"],
    "data": [
      { "size": 10, "grams": [2, 3, 4] },
      { "size": 11, "grams": [2, 3, 4] },
      { "size": 12, "grams": [2, 3, 4] },
      { "size": 13, "grams": [2, 3, 4] },
      { "size": 14, "grams": [2, 3, 4] },
      { "size": 15, "grams": [2, 3, 4] },
      { "size": 16, "grams": [2, 3, 4] },
      { "size": 17, "grams": [2, 3, 4] },
      { "size": 18, "grams": [2, 3, 4] },
      { "size": 19, "grams": [2, 3, 4] },
      { "size": 20, "grams": [2, 3, 4] }
    ]
  },
  {
    "name": "916 GETTI RING",
    "gender":["MALE"],
    "data": [
      { "size": 21, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 22, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 23, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 24, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 25, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 26, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 27, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 28, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 29, "grams": [6, 8, 12, 16, 20, 24] },
      { "size": 30, "grams": [6, 8, 12, 16, 20, 24] }
    ]
  },

  {
    "name": "916 PENDANTS",
    "data": [
      { "inches": "<1\" WITH BOW HOOK", "grams": 1.5 },
      { "inches": "1\" WITH BOW HOOK", "grams": 2.5 },
      { "inches": "1.25\" WITH BOW HOOK", "grams": 4 },
      { "inches": "1.5\" WITH BOW HOOK", "grams": 6 },
      { "inches": "2\" TO 2.5\" WITH BOW HOOK", "grams": 8 }
    ]
  },
    {
    "name": "916 POOJAI VEL",
    "data": [
      { "inches": "2.75\"", "grams": 6 },
      { "inches": "5\"", "grams": 20 },
      { "inches": "7\"", "grams": 40 },
      { "inches": "9\"", "grams": 56 },
      { "inches": "12\"", "grams": 80 }
    ]
  },
  {
    "name": "HOLLOW PIPE ROUND KADA BANGLE ",
      "gender":["MALE"],
    "data": [
      { "size": "1.10.16", "grams": 4 },
      { "size": "1.12.16", "grams": 4 },
      { "size": "1.14.16", "grams": 4 },
      { "size": "2", "grams": 4 }
    ]
  },
  {
    "name": "HOLLOW PIPE ROUND KADA",
         "gender":["LADIES","BOYS","GIRLS"],
    "data": [
      { "size": "2.2", "grams": 8 },
      { "size": "2.4", "grams": 10 },
      { "size": "2.6", "grams": 10 },
      { "size": "2.8", "grams": 12 }
    ]
  },
  {
    "name": "GETTI PIPE ROUND KADA",
      "gender":["LADIES","BOYS","GIRLS"],
    "data": [
      { "size": "2.2", "grams": 20 },
      { "size": "2.4", "grams": 24 },
      { "size": "2.6", "grams": 28 },
      { "size": "2.8", "grams": 32 }
    ]
  },
  {
    "name": "GETTI PIPE ROUND GENTS KADA",
      "gender":["MALE"],
    "data": [
      { "size": "2.1", "grams": 40 },
      { "size": "2.12", "grams": 48 },
      { "size": "2.14", "grams": 56 },
      { "size": "3", "grams": 80 }
    ]
  }
    ]
    return customizationData;
  }

  const getSilverProductCustomizationData = () => {
    const silverCustomization = [
  {
    "name": "925 HOLLOW RING",
    "gender":["UNISEX"],
    "data": [
      { "size": 10, "grams": [3, 4, 5] },
      { "size": 11, "grams": [3, 4, 5] },
      { "size": 12, "grams": [3, 4, 5] },
      { "size": 13, "grams": [3, 4, 5] },
      { "size": 14, "grams": [3, 4, 5] },
      { "size": 15, "grams": [3, 4, 5] },
      { "size": 16, "grams": [3, 4, 5] },
      { "size": 17, "grams": [3, 4, 5] },
      { "size": 18, "grams": [3, 4, 5] },
      { "size": 19, "grams": [3, 4, 5] },
      { "size": 20, "grams": [3, 4, 5] }
    ]
  },
  {
    "name": "916 GETTI RING",
    "gender":["MALE"],
    "data": [
      { "size": 21, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 22, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 23, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 24, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 25, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 26, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 27, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 28, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 29, "grams": [10,11,12,13,14,15,16,17,18,19,20] },
      { "size": 30, "grams": [10,11,12,13,14,15,16,17,18,19,20] }
    ]
  },
  {
    "name": "916 POOJAI VEL",
    "data": [
      { "inches": "2.75\"", "grams": 6 },
      { "inches": "5\"", "grams": 20 }
    ]
  },
  {
    "name": "925 PENDANTS",
    "gender":["UNISEX"],
    "data": [
      { "inches": "<1\" WITH BOW HOOK", "grams": 2 },
      { "inches": "1\" WITH BOW HOOK", "grams": 4 },
      { "inches": "1.25\" WITH BOW HOOK", "grams": 5 },
      { "inches": "1.5\" WITH BOW HOOK", "grams": 6 },
      { "inches": "2\" TO 2.5\" WITH BOW HOOK", "grams": 8 }
    ]
  },
  {
    "name": "925 HOLLOW PIPE ROUND KADA BANGLE FOR BABY",
    "data": [
      { "size": "1.10.16", "grams": [4, 6, 8] }
    ]
  },
  {
    "name": "925 HOLLOW PIPE ROUND KADA",
    "gender":["LADIES","BOYS","GIRLS"],
    "data": [
      { "size": "2.2", "grams": 20 },
      { "size": "2.4", "grams": 20 },
      { "size": "2.6", "grams": 20 },
      { "size": "2.8", "grams": 20 }
    ]
  },
  {
    "name": "925 GETTI PIPE ROUND GENTS KADA",
    "gender":["MALE"],
    "data": [
      { "size": "2.1", "grams": 50 },
      { "size": "2.12", "grams": 50 },
      { "size": "2.14", "grams": 50 },
      { "size": "3", "grams": 50 }
    ]
  }
]
  return silverCustomization;
  }

  // const createCustomerEnquiry = () => {
  //   const demoEndDate = moment(scheduleDate, "YYYY-MM-DDThh:mm")
  //     .add(20, "minutes")
  //     .format("DD-MM-YYYY hh:mm A");
  //   const newDemoStartDate = moment(scheduleDate, "YYYY-MM-DDThh:mm").format(
  //     "YYYY-MM-DD HH:mm:ss"
  //   );
  //   const newDemoEndDate = moment(demoEndDate, "DD-MM-YYYY hh:mm A").format(
  //     "YYYY-MM-DD HH:mm:ss"
  //   );
  //   const newPreviousFollowUpDate = currentDateToUtcDate(newDemoStartDate);
  //   const newNextFollowupDate = currentDateToUtcDate(newDemoEndDate);
  //   const currentDateAndTime = currentRegister();
  //   const newCurrentDate = currentDateToUtcDate(currentDateAndTime);
  //   const customerEmail = getCustomerMail()
  //   const customerData = {};
  //   customerData.id = getCustomerId();
  //   customerData.name = getCustomerName()
  //   customerData.branchId = getBranchId();
  //   customerData.email = customerEmail
  //   customerData.enquirySource = "WEB";
  //   customerData.crmStatus = "ENGAGING";
  //   customerData.enrollmentDate = newCurrentDate;
  //   customerData.customerAddress = getCustomerAddress()
  //   customerData.countryCode = "+91";
  //   customerData.customerType = "CUSTOMER";
  //   customerData.homeCountry = "LOCAL";
  //     let enquiryInfo = `Metal:${selectedMetal},Category:${selectedCategory},ProductName:${productInfo},Gender:${selectedGender ? selectedGender : 'Not Mentioned'},Grams:${selectedGrams},Size:${selectedSize}`
  //     const reqInfo = `Custom Order: ${enquiryInfo}`
  //   let productId =  null;

  //   const enquiryData = {
  //         customer: customerData,
  //         enquirySourceId: EnquieryId[0]?.id ?? null,
  //         enquiryStatusId: EnquieryStatusId,
  //         enqGeneratedById: EmployeeId,
  //         productId: productId,
  //         prevFollowUpDate: newPreviousFollowUpDate,
  //         nextFollowUpDate: newNextFollowupDate,
  //         enquiryTypeId: EnquieryTypeid,
  //         reqDetails: reqInfo,
  //         branchId: getBranchId(),
  //         languageId: currentlang.value !== null ? currentlang.value : null,
  //         metalTypeid: selectedMetal.id !== null ? selectedMetal.id : null,
  //       };
  //   createEnquiry(JSON.stringify(enquiryData))
  //   .then((data) => {
  //     console.log('enquiry created successfully');
  //   })
  //   .catch((err) => {
  //     console.error(`not created because of ${err}`)
  //   })
  // }

 const addProductOrderDetails = () => {
    // setOpengateWay(true);
    const branchId = getBranchId()
    const v1Date = moment().format(YEAR_WISE_FORMAT)
    const v2Date = `${v1Date} ${getCurrentTimeConfig()}`
    const date = currentDateToUtcDate(v2Date)
    const expDate = moment().add(30,'days').format(YEAR_WISE_FORMAT)
    const exV3Date = `${expDate} ${getCurrentTimeConfig()}`
    const expectedDateInfo = currentDateToUtcDate(exV3Date)
    const customerId = getCustomerId()
    const statusHistoryInfo = [{
      status:'Confirmed',
      updated_date:date,
      updated_by:'',
      updatedByName:'Select'
    }]
    const paymentModeInfo = [{
      tax:[
        {expectedAmount: totalAmount - taxData},
        {
          value:selectedTax[0].value,
          label:selectedTax[0].label,
          name:selectedTax[0].name,
          percent:selectedTax[0].percent,
          taxAmt:taxData
        }
      ],
      name:selectedPayment[0].label,
      remarks:'RECEIVED',
      value:totalAmount,
      payableAmount:totalAmount,
      paymentMode:selectedPayment[0].value,
      bankAccountId:null,
      paymentCash:true,
      expectedAmt:totalAmount,
      paymentMetal: false,
      customerPaymentId: null,
      customerPaymentName: null,
      processingFeeInPercent: 0,
      processingFeeTaxInPercent: 0,
      processingFeeInValue: 0,
      processingFeeTaxInValue: 0,
    }]
    const productOrderReceiptData = [{
      acceptedAmount:totalAmount,
      balanceAmount:0,
      branch:branchId,
      customerId:customerId,
      expectedAmount:totalAmount,
      paidAmount:totalAmount,
      paidDate:date,
      paymentMode:JSON.stringify(paymentModeInfo),
      priceRateType:'Delivery Rate',
      status:'Confirmed',
      statusHistory:JSON.stringify(statusHistoryInfo)
    }]
    const otherCharges = [{
      stone:[]
    }]
    const productOrderItemList = [{
      branchId:branchId,
      deleteProdOrderItemId:'',
      description:'',
      expectedAmt:totalAmount,
      expectedDate:expectedDateInfo,
      fbScore:0,
      financialYearMetadataId:financialyear,
      floorId:selectedFloor[0].value, 
      huId:'',
      mcType:'rs',
      mcUnit : 'pergm',
      metaProdTypeId:selectedMetal === 'Gold' ? goldType : silverType,
      metaPurityId:selectedMetal === 'Gold' ? goldPurityId : silverPurityId,
      metaSpecificationId:null,
      metaSpecificationName:'Select',
      metalRate:selectedMetal === 'Gold' ? goldRate : silverRate,
      netOrderWastage:0,
      orderGrossWeight:selectedGrams,
      orderLessWeight:0,
      orderMCValue:0,
      orderNetMc:0,
      orderNetWeight:0,
      orderOtherCharges:JSON.stringify(otherCharges),
      orderScValue:0,
      orderStatusId:null,
      orderType:'CUSTOMIZATION',
      orderWastageValue:0,
      piece:1,
      priority:'Medium',
      productAdvanceItemImageList:[],
      productCategoryId:productCategory[0]?.value,
      productId:null,
      productName:productInfo,
      productStandardMetadataId:null,
      productSubcategoryId:prodSubCategory[0]?.value,
      receivedDate:date,
      remark:`Metal:${selectedMetal},Category:${selectedCategory},ProductName:${productInfo},Gender:${selectedGender ? selectedGender : 'Not Mentioned'},,Grams:${selectedGrams},Size:${selectedSize}`,
      scType:'rs',
      sectionDetailsId:selectedSelection[0].value,
      statusId:orderStatus.id,
      totalOrderScValue:0,
      vendorId:null,
      wastageType:'percentage'
    }]
    const productOrderDetails = JSON.stringify({
      branch:branchId,
      custPayableAmount:totalAmount,
      custPrevCredit:0,
      custPrevDebit:0,
      customer:customerId,
      customerCreditDetails:null,
      customerCurrentCredit:totalAmount,
      customerCurrentDebit:0,
      customerMetalCredit:null,
      exchange:null,
      financialYear:financialyear,
      ledgerDetailsDomainList:null,
      prodAdvRcpt:productOrderReceiptData,
      productOrderItems:productOrderItemList
    })
          const requestData = {
             customerId: customerId,
             chitId: null,
             branchId: getBranchId(),
             paymentPurpose: "ECOMM_WEB_SALES",
             requestChannel: "WEB",
             gateWayName: "PAYU",
             paymentAmount: totalAmount.toFixed(2),
            };
          const responseData = getPayULinkData(requestData)
          responseData.then(
              data => {
                console.log('payment',data);
                // setTransData(data.response)
                const payuRequest = {
                  accountId:"13411645",
                  txnId:data.response.orderId,
                  order:{
                    productInfo:productInfo,
                    paymentChargeSpecification:{
                      price:data.response.amount
                    }
                  },
                  billingDetails:{
                    firstName:data.response.customerName,
                    address1:data.response?.customerAddr !== null ? data.response?.customerAddr : 'Thiruvanmiyur',
                    email:data.response.customerEmail
                  },
                  callBackActions:{
                    successAction:'https://billing.mgdm.in/VelProductDetails',
                    failureAction:'https://billing.mgdm.in/VelProductDetails',
                    cancelAction:'https://billing.mgdm.in/VelProductDetails'
                  },
                  additionalInfo:{
                    createOrder:true
                  }
                }
                const { date: authDate, authorization:auth } = getAuthHeader(payuRequest);
                const payuResponse = fetch('https://apitest.payu.in/v2/payments', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'date': authDate,
                    'authorization': auth
                  },
                  body: JSON.stringify(payuRequest)
                })
                payuResponse.then(
                  response => response.json()
                ).then(
                  payuResult => {
                    console.log('PayU Response:', payuResult);
                    if (payuResult.status === 'success') {
                      toast.success("Payment Initiated!");
                      // setTransData(payuResult); // If needed
                      const response = createProductOrder(productOrderDetails)
                      response.then(
                        data => {
                          console.log('respo',data);
                          toast.success('Product is Booked!!')
                        }
                      )
                    }
                  }
                ).catch(
                  error => {
                    console.error('PayU Error:', error);
                    toast.error("Payment initiation failed");
                  }
                );
              }
            )
  }


 return (
  <StyledDiv>
    <Toaster position="top-right" />
    
    {/* Breadcrumb Navigation */}
    <div className="px-sm-5 px-3" style={{ paddingTop: "1rem", fontSize: "0.9rem" }}>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb m-0">
          <li className="breadcrumb-item">
            <Link to="/" className="text-decoration-none text-secondary">
              Home
            </Link>
          </li>
          <li className="breadcrumb-item active text-custom-100" aria-current="page">
            {productInfo?.toLowerCase()}
          </li>
        </ol>
      </nav>
    </div>

    {/* Main Product Section */}
    <div className="container my-4">
      <div className="row g-4">
        
        {/* Left Column - Product Images */}
        <div className="col-lg-6 col-md-6">
          <div className="card border-0 shadow-sm rounded-3 overflow-hidden">
            <div className="position-relative">
              <span style={{ cursor: "zoom-in" }}>
                <ZoomableImage 
                  src={currentImg} 
                  style={{ width: "100%", height: "auto" }}
                />
              </span>
              
              {/* Wishlist and Share Buttons */}
              <div className="position-absolute top-0 end-0 p-3 d-flex gap-2">
                <button
                  type="button"
                  className={`btn btn-light btn-sm rounded-circle shadow-sm ${
                    wishState[categoryItem.id] ? "text-danger" : "text-secondary"
                  }`}
                  onClick={() => wishCountFunc(categoryItem)}
                  style={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  title="Add to Wishlist"
                >
                  <i className={`bi bi-heart${wishState[categoryItem.id] ? "-fill" : ""}`}></i>
                  {categoryItem.wishListCount > 0 && (
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {categoryItem.wishListCount}
                    </span>
                  )}
                </button>
                
                <button
                  type="button"
                  className="btn btn-light btn-sm rounded-circle shadow-sm"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  style={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  title="Share"
                >
                  <i className="bi bi-share text-secondary"></i>
                </button>
              </div>
            </div>
            
            {/* Thumbnail Images */}
            <div className="p-3 bg-light">
              <div className="d-flex flex-wrap gap-2 justify-content-start">
                {Img.map((image, index) => (
                  <div
                    key={index}
                    className={`thumbnail-wrapper ${currentImg === image ? "active" : ""}`}
                    onClick={() => setCurrentImg(image)}
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "8px",
                      overflow: "hidden",
                      cursor: "pointer",
                      border: currentImg === image ? "2px solid #811331" : "2px solid transparent",
                      padding: "2px"
                    }}
                  >
                    <img
                      src={image}
                      alt={`Thumbnail ${index + 1}`}
                      className="img-fluid h-100 w-100"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                ))}
              </div>
            </div>
            
            {/* Product Specifications */}
            <div className="p-3 border-top">
              {/* WhatsApp Button */}
              <div 
              className="d-grid"
              title={isMandatory ? "Please fill mandatory field" : ""}
              >
                <button
                  type="button"
                  className="btn btn-success d-flex align-items-center justify-content-center gap-2 py-2"
                  style={{
                    borderRadius: "25px",
                    background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',

                    border: "none",
                    fontWeight: "600",
                    transition: "all 0.3s ease"
                  }}
                  disabled={isMandatory}
                  onClick={handleWhatsAppClick} 

                  onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.02)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                >
                  <i className="bi bi-whatsapp fs-5"></i>
                  <span>Click For Further Discussion</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Product Details */}
        <div className="col-lg-6 col-md-6">
          <div className="card border-0 shadow-sm rounded-3 h-100">
            <div className="card-body py-0">
              {/* Product Title and Code */}
           <div className="mb-4">
  <div className="d-flex align-items-start justify-content-between mb-2">
    {/* Product Name + Description - left side */}
    <div>
      <h1 className="h2 fw-bold text-dark mb-1">
        {productInfo || "Product Name"}
      </h1>
      <span className="text-muted d-block" style={{fontSize:'15px'}}>
        {categoryInfo}
      </span>
      <span className="d-block" style={{fontStyle:'italic',fontSize:'15px',color:colorCode}}>
        {descriptionInfo}
      </span>
    </div>
    
    {/* Back Button - right end, same line as product name */}
    <div>
      <button
        className="btn btn-link p-0"
        style={{ color: "#811331", fontWeight: 500 }}
        onClick={() => 
          navigate("/VelSeriesDetails", { 
            state: { isDashboard: true,languageInfo:location?.state?.language } 
          })
        }
      >
        Back
      </button>
    </div>
  </div>
</div>



              {/* Price Display */}
              {/* {Number.isFinite(Details.total) && ( */}
                <div className="mb-4">
                  <div></div>
                  <div className="d-flex align-items-baseline gap-2">
                    <span className="text-muted" style={{ fontSize: "0.9rem" }}>Total Price</span>
                    {totalAmount > 0 ? (
                    <h2 className="text-dark fw-bold mb-0">
                      ₹ {Math.trunc(totalAmount).toLocaleString('en-IN')}
                    </h2>
                    ) : 
                    <h2 className="text-dark" style={{fontSize:'15px'}}>
                      Customize Your Order
                    </h2>
                    }
                  </div>
                  <small className="text-muted d-block">
                    <i className="bi bi-info-circle me-1"></i>
                    Inclusive of all taxes and charges
                  </small>
                  
                 </div>

               {/* Action Buttons */}
               <div className="mb-4 d-flex flex-wrap gap-3">
                <button
                  className="btn d-flex align-items-center justify-content-center gap-2 px-4 py-2 btn-outline-primary"
                  style={{
                    minWidth: "250px",
                    borderRadius: "25px",
                    fontWeight: "600",
                  }}
                  onClick={() => navigate("/BookAnAppointment")}
                >
                  <img
                    src={tryit}
                    style={{ height: "20px", width: "auto", color: '#811331'}}
                    alt="Try It On"
                  />
                  <span>Book An Appointment</span>
                </button>
                
              </div>

              {/* Details Tabs */}
              <div className="mb-4">
                <ul className="nav nav-tabs" id="productDetailsTab" role="tablist">
                     <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${selectedTab === "customization" ? "active" : ""}`}
                      id="customization-tab"
                      onClick={() => setSelectedTab("customization")}
                      style={{
                        color: selectedTab === "customization" ? "#811331" : "#6c757d",
                        fontWeight: "500"
                      }}
                    >
                      Customization
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${selectedTab === "price" ? "active" : ""}`}
                      id="price-tab"
                      onClick={() => setSelectedTab("price")}
                      style={{
                        color: selectedTab === "price" ? "#811331" : "#6c757d",
                        fontWeight: "500"
                      }}
                    >
                      Price Breakup
                    </button>
                  </li>
                </ul>

                <div className="tab-content border border-top-0 rounded-bottom p-3">
                    {/* Customization Tab */}
                {selectedTab === "customization" && (
  <div className="tab-pane fade show active">
    <div className="row g-3">
      {/* METAL – buttons */}
      <div className="col-md-6">
        <label className="form-label fw-semibold">Metal</label>
        <span className="text-danger">*</span>
        <div className="d-flex flex-wrap">
          {["Gold", "Silver"].map((metal) => (
            <button
              key={metal}
              className={`btn btn-sm ${
                selectedMetal === metal ? "btn-custom-red" : "btn-outline-mgdm"
              }`}
              onClick={() => {
                setSelectedMetal(metal);
                setSelectedCategory("");
                setSelectedGender("");
                setSelectedSize("");
                setSelectedGrams("");
                setOpenCustomizationKey("");
                setTotalAmount(0);
                setTaxData(0);
                setMakingChargeInfo(0);
                setWastageInfo(0);
              }}
            >
              {metal}
            </button>
          ))}
        </div>
      </div>

      {/* CATEGORY DROPDOWN */}
<div className="col-md-6">
  <label className="form-label fw-semibold">Category</label>
 <span className="text-danger">*</span>
  <div className="position-relative">
    <div
      className={`border rounded px-3 py-2 d-flex justify-content-between align-items-center ${
        !isMetalSelected ? "bg-light" : ""
      }`}
      style={{
        cursor: isMetalSelected ? "pointer" : "not-allowed",
        opacity: isMetalSelected ? 1 : 0.6,
      }}
      onClick={() => {
        if (!isMetalSelected) return;
        setOpenCustomizationKey(
          openCustomizationKey === "category" ? "" : "category"
        );
      }}
    >
      <span>{selectedCategory || "Select"}</span>
      <i
        className={`bi bi-chevron-${
          openCustomizationKey === "category" ? "up" : "down"
        }`}
      />
    </div>

    {openCustomizationKey === "category" && (
      <div className="dropdown-overlay">
        {(selectedMetal === "Gold"
          ? getGoldProductCustomizationData().map((cat) => cat.name)
          : getSilverProductCustomizationData().map((cat) => cat.name)
        ).map((name) => (
          <div
            key={name}
            className="p-2 custom-option"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedCategory(name);
              setSelectedGender("");
              setSelectedSize("");
              setSelectedGrams("");
              setOpenCustomizationKey("");
            }}
          >
            {name}
          </div>
        ))}
      </div>
    )}
  </div>
</div>

{/* GENDER DROPDOWN */}
<div className="col-md-6">
  <label className="form-label fw-semibold">Gender</label>

  <div className="position-relative">
    <div
      className={`border rounded px-3 py-2 d-flex justify-content-between align-items-center ${
        !selectedCategory ? "bg-light" : ""
      }`}
      style={{
        cursor: selectedCategory ? "pointer" : "not-allowed",
        opacity: selectedCategory ? 1 : 0.6,
      }}
      onClick={() => {
        if (!selectedCategory) return;
        setOpenCustomizationKey(
          openCustomizationKey === "gender" ? "" : "gender"
        );
      }}
    >
      <span>{selectedGender || "Select"}</span>
      <i
        className={`bi bi-chevron-${
          openCustomizationKey === "gender" ? "up" : "down"
        }`}
      />
    </div>

    {openCustomizationKey === "gender" && (
      <div className="dropdown-overlay">
        {(() => {
          if (
            (selectedMetal === "Gold" || selectedMetal === "Silver") &&
            selectedCategory
          ) {
            const cat =
              selectedMetal === "Gold"
                ? getGoldProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  )
                : getSilverProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  );

            const genders = cat?.gender || [];

            if (!genders.length)
              return <div className="text-muted p-2">Not applicable</div>;

            return genders.map((g) => (
              <div
                key={g}
                className="p-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedGender(g);
                  setOpenCustomizationKey("");
                }}
              >
                {g}
              </div>
            ));
          }
        })()}
      </div>
    )}
  </div>
</div>

{/* SIZE DROPDOWN */}
<div className="col-md-6">
  <label className="form-label fw-semibold">Size</label>
 <span className="text-danger">*</span>
  <div className="position-relative">
    <div
      className="border rounded px-3 py-2 d-flex justify-content-between align-items-center"
      style={{ cursor: "pointer" }}
      onClick={() =>
        setOpenCustomizationKey(
          openCustomizationKey === "size" ? "" : "size"
        )
      }
    >
      <span>{selectedSize || "Select"}</span>
      <i
        className={`bi bi-chevron-${
          openCustomizationKey === "size" ? "up" : "down"
        }`}
      />
    </div>

    {openCustomizationKey === "size" && (
      <div className="dropdown-overlay">
        {(() => {
          if (
            (selectedMetal === "Gold" || selectedMetal === "Silver") &&
            selectedCategory
          ) {
            const cat =
              selectedMetal === "Gold"
                ? getGoldProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  )
                : getSilverProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  );

            if (!cat?.data?.length)
              return <div className="text-muted p-2">Not available</div>;

            return cat.data.map((d, idx) => {
              const label = d.size ?? d.inches;
              const value =
                d.size !== undefined ? String(d.size) : String(d.inches);
              return (
                <div
                  key={idx}
                  className="p-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedSize(value);

                    if (Array.isArray(d.grams) && d.grams.length > 1) {
                      setSelectedGrams(d.grams[0]);
                      getPriceData(d.grams[0])
                    } else if (typeof d.grams === "number") {
                      setSelectedGrams(d.grams);
                      getPriceData(d.grams)
                    } else {
                      setSelectedGrams("");
                    }

                    setOpenCustomizationKey("");
                  }}
                >
                  {label}
                </div>
              );
            });
          }
        })()}
      </div>
    )}
  </div>
</div>

{/* GRAMS DROPDOWN */}
<div className="col-md-6">
  <label className="form-label fw-semibold">Grams</label>
 <span className="text-danger">*</span>
  <div className="position-relative">
    <div
      className={`border rounded px-3 py-2 d-flex justify-content-between align-items-center ${
        !selectedSize ? "bg-light" : ""
      }`}
      style={{
        cursor: selectedSize ? "pointer" : "not-allowed",
        opacity: selectedSize ? 1 : 0.6,
      }}
      onClick={() => {
        if (!selectedSize) return;
        setOpenCustomizationKey(
          openCustomizationKey === "grams" ? "" : "grams"
        );
      }}
    >
      <span>{selectedGrams ? `${selectedGrams}g` : "Select"}</span>
      <i
        className={`bi bi-chevron-${
          openCustomizationKey === "grams" ? "up" : "down"
        }`}
      />
    </div>

    {openCustomizationKey === "grams" && (
      <div className="dropdown-overlay">
        {(() => {
          if (
            (selectedMetal === "Gold" || selectedMetal === "Silver") &&
            selectedCategory &&
            selectedSize
          ) {
            const cat =
              selectedMetal === "Gold"
                ? getGoldProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  )
                : getSilverProductCustomizationData().find(
                    (c) => c.name === selectedCategory
                  );

            const item = cat?.data?.find((d) => {
              const v =
                d.size !== undefined ? String(d.size) : String(d.inches);
              return v === selectedSize;
            });

            const gramsArr = Array.isArray(item?.grams)
              ? item.grams
              : typeof item?.grams === "number"
              ? [item.grams]
              : [];

            if (!gramsArr.length)
              return <div className="text-muted p-2">Not available</div>;

            return gramsArr.map((g) => (
              <div
                key={g}
                className="p-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedGrams(g);
                  setOpenCustomizationKey("");
                  getPriceData(g)
                }}
              >
                {g}g
              </div>
            ));
          }
        })()}
      </div>
    )}
  </div>
</div>

<div className="col-md-6 pt-4">
    <button
                  className="d-flex btn-outline-primary align-items-center justify-content-center gap-2 px-4 py-2"
                  style={{ borderRadius: "25px", fontWeight: "600" }}
                  onClick={() =>  buynow()}
                >
                  <i className="bi bi-bag-heart"></i>
                  <span>Book Your Order</span>
                  {totalAmount > 0 &&
                  <span> ₹ {Math.trunc((totalAmount)).toLocaleString('en-IN')}</span>
                  }
                </button>
</div>


    </div>
  </div>
)}
                  {/* Product Details Tab */}
                  {selectedTab === "product" && (
                    <div className="tab-pane fade show active">
                      <Accordion defaultActiveKey="0">
                        {/* Metal Details */}
                        <Accordion.Item eventKey="0" className="border-0 mb-2">
                          <Accordion.Header className="bg-light rounded">
                            <div className="d-flex align-items-center gap-2">
                              <i className="bi bi-gem text-mgdm"></i>
                              <span className="fw-medium">METAL DETAILS</span>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="row g-3">
                              <div className="col-md-4">
                                <div className="text-center p-2 bg-light rounded">
                                  <div className="text-muted small">Metal Type</div>
                                  <div className="fw-semibold">{selectedMetal || "-"}</div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="text-center p-2 bg-light rounded">
                                  <div className="text-muted small">Wastage</div>
                                  <div className="fw-semibold">
                                    {wastageInfo}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="text-center p-2 bg-light rounded">
                                  <div className="text-muted small">Making Charges</div>
                                  <div className="fw-semibold">
                                    {`₹${makingChargeInfo.toLocaleString('en-IN')}`}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>

                      </Accordion>
                    </div>
                  )}

                  {/* Price Breakup Tab */}
                  {selectedTab === "price" && (
                    <div className="tab-pane fade show active">
                      <div className="table-responsive">
                        <table className="table table-bordered mb-0">
                          <thead className="table-light">
                            <tr>
                              <th className="fw-semibold">COMPONENT</th>
                              <th className="fw-semibold text-end">AMOUNT (₹)</th>
                              <th className="fw-semibold">REMARKS</th>
                            </tr>
                          </thead>
                           <tbody>
                             {/* Gold Value */}
                             <tr>
                               <td>
                                 <div className="d-flex align-items-center gap-2">
                                   <i class="bi bi-coin icon-gold"></i>
                                   <span>Metal Value</span>
                                 </div>
                               </td>
                               <td className="text-end fw-semibold">
                                 {totalAmount ? `₹${Math.trunc(selectedGrams * (selectedMetal === 'Gold' ? goldRate : silverRate)).toLocaleString('en-IN')}` : "-"}
                               </td>
                              <td>
                                <small className="text-muted">
                                  {selectedGrams} gm × ₹{(selectedMetal === 'Gold' ? goldRate : silverRate)?.toLocaleString('en-IN') || "-"}/gm
                                </small>
                              </td>
                            </tr>

                            {/* Wastage Charges */}
                            {selectedMetal === 'Gold' ? (
                            <tr>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <i className="bi bi-plus-circle text-primary"></i>
                                  <span>Wastage Charges</span>
                                </div>
                              </td>
                              <td className="text-end fw-semibold">
                                {`₹${Math.trunc((selectedGrams * 18.2/100) * goldRate ).toLocaleString('en-IN')}`}
                              </td>
                              <td>
                                <small className="text-muted">
                                  {18.2}% of gold value
                                </small>
                              </td>
                            </tr>
                                ) : null}
                            {/* Making Charges */}
                            {selectedMetal === 'Gold' ? (
                            <tr>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <i className="bi bi-tools text-info"></i>
                                  <span>Making Charges</span>
                                </div>
                              </td>
                              <td className="text-end fw-semibold">
                                { `₹${Math.trunc(makingChargeInfo).toLocaleString('en-IN')}`}
                              </td>
                              <td>
                                <small className="text-muted">Craftsmanship charges</small>
                              </td>
                            </tr>
                          ) : null}

                            {/* Gemstone Cost */}
                            {/* {Details.gemTotal > 0 && (
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-diamond text-success"></i>
                                    <span>Gemstone Cost</span>
                                  </div>
                                </td>
                                <td className="text-end fw-semibold">
                                  ₹{Math.trunc(Details.gemTotal).toLocaleString('en-IN')}
                                </td>
                                <td>
                                  <small className="text-muted">
                                    {Details.gemstoneWeight || "-"} ct × ₹{Details.gemCost || "-"}/ct
                                    ({Details.gemstoneType})
                                  </small>
                                </td>
                              </tr>
                            )} */}

                            {/* Hallmark Charges */}
                            {/* {Details.hmTotal > 0 && (
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-shield-check text-danger"></i>
                                    <span>Hallmark Charges</span>
                                  </div>
                                </td>
                                <td className="text-end fw-semibold">
                                  ₹{Math.trunc(Details.hmTotal).toLocaleString('en-IN')}
                                </td>
                                <td>
                                  <small className="text-muted">BIS Certification</small>
                                </td>
                              </tr>
                            )} */}

                            {/* Taxes */}
                            {/* {Details.saleTaxList?.map((tax, index) => ( */}
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-percent text-secondary"></i>
                                    <span>{'CGST & SGST'}</span>
                                  </div>
                                </td>
                                <td className="text-end fw-semibold">
                                  ₹{Math.trunc(taxData).toLocaleString('en-IN')}
                                </td>
                                <td>
                                  <small className="text-muted">{3}%</small>
                                </td>
                              </tr>
                         {/* ))} */}

                            {/* Other Charges */}
                            {/* {Details.otherCharge > 0 && (
                              <tr>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <i className="bi bi-plus-circle text-muted"></i>
                                    <span>Other Charges</span>
                                  </div>
                                </td>
                                <td className="text-end fw-semibold">
                                  ₹{Math.trunc(Details.otherCharge).toLocaleString('en-IN')}
                                </td>
                                <td>
                                  <small className="text-muted">{Details.otherChargeRemark || "Additional charges"}</small>
                                </td>
                              </tr>
                            )} */}

                            {/* Total Row */}
                            <tr className="table-primary">
                              <td className="fw-bold">
                                <div className="d-flex align-items-center gap-2">
                                  <i className="bi bi-currency-rupee"></i>
                                  <span>TOTAL AMOUNT</span>
                                </div>
                              </td>
                              <td className="text-end fw-bold fs-5">
                                ₹ {Math.trunc((totalAmount)).toLocaleString('en-IN')}
                              </td>
                              <td>
                                <small className="text-muted">Inclusive of all charges</small>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                    <span>
                      Note:  *Shipping charges will be applicable as per location.
                    </span>
                      </div>

                      {/* Summary Card */}
                      {/* <div className="mt-3">
                        <div className="card border-mgdm">
                          <div className="card-body">
                            <h6 className="card-title fw-bold mb-3">Price Summary</h6>
                            <div className="row g-3">
                              <div className="col-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Gold Rate Today:</span>
                                  <span className="fw-semibold">
                                    ₹{Details.todayRate?.toLocaleString('en-IN') || "-"}/gm
                                  </span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Purity:</span>
                                  <span className="fw-semibold">{Details.goldPurity || "-"}</span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Price per gram:</span>
                                  <span className="fw-semibold">
                                    ₹{(Details.total / Details.weight?.grossWeight || 0).toFixed(2)}
                                  </span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted">Effective Rate:</span>
                                  <span className="fw-semibold">
                                    ₹{((Details.total / Details.weight?.grossWeight || 0) * (1000/916)).toFixed(2)} (24K equivalent)
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Buying Guide Banner */}
    <div className="container my-5">
      <div className="position-relative rounded-3 overflow-hidden">
        <img
          src={ad}
          className="img-fluid w-100"
          alt="Buying Guide"
          style={{ height: "200px", objectFit: "cover" }}
        />
        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-white p-4"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <h4 className="fw-bold mb-2">Not sure what to buy?</h4>
          <p className="mb-3">Let us help you in making that decision</p>
          <button
            className="btn btn-light px-4 py-2 d-flex align-items-center gap-2"
            onClick={handleButtonClick}
          >
            View Buying Guides
            <i className="bi bi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>

    {/* Related Products */}
    {/* <div className="container my-5">
      <RelatedProduct Details={Details} />
    </div> */}

    {/* Sticky Footer for Mobile */}
     {/* {(opengateWay && transData.amount) &&(
        <div
          className="custom-modal-overlay d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            zIndex: 9999,
          }}
        >
          <div
            className="custom-modal-content p-4 rounded"
            style={{
              width: "450px",
              background: "#fff",
              boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
              animation: "fadeIn 0.3s ease",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <button
                className="btn btn-sm btn-light"
                onClick={() => setOpengateWay(false)}
              >
                ✕
              </button>
            </div>

            {transData.amount > 0 ? (
            <div>
              <div className="mt-3">
               <AffordabilityWidget
                  payuKey="Kv9ij7"
                  amount={Math.trunc(transData.amount)}
                  transData={transData}
                  propsInfo = {location?.state?.categoryItem}
                /> 
              </div>
            </div>
            ):null}
          </div>
        </div>
      )} */}
  </StyledDiv>
);
};